// Define PPO options interface
export interface PPOOption {
  id: string;
  label: string;
  hasLicense?: boolean;
}

// Define PPO constants
export const PPO = {
  ALL: 'ALL',
  ATA: 'ATA',
  AZA: 'AZA',
  BEA: 'BEA',
  BGA: 'BGA',
  BRA: 'BRA',
  CAA: 'CAA',
  CFA: 'CFA',
  CHA: 'CHA',
  CUA: 'CUA',
  CYA: 'CYA',
  CZA: 'CZA',
  DEA: 'DEA',
  DKA: 'DKA',
  DZA: 'DZA',
  EEA: 'EEA',
  EGA: 'EGA',
  ESA: 'ESA',
  FIA: 'FIA',
  FRA: 'FRA',
  GBA: 'GBA',
  GHA: 'GHA',
  GRA: 'GRA',
  HKA: 'HKA',
  HRA: 'HRA',
  HUA: 'HUA',
  IEA: 'IEA',
  IPC: 'IPC',
  ISA: 'ISA',
  ITA: 'ITA',
  JEA: 'JEA',
  LTA: 'LTA',
  LUA: 'LUA',
  LVA: 'LVA',
  MTA: 'MTA',
  NLA: 'NLA',
  NOA: 'NOA',
  PLA: 'PLA',
  PLG: 'PLG',
  PTA: 'PTA',
  PYA: 'PYA',
  ROA: 'ROA',
  RUA: 'RUA',
  SEA: 'SEA',
  SGA: 'SGA',
  SIA: 'SIA',
  SKA: 'SKA',
  SNA: 'SNA',
  THA: 'THA',
  TRA: 'TRA',
  TWA: 'TWA',
  USA: 'USA',
  UYA: 'UYA'
} as const;

// Define PPO options with metadata
export const PPO_OPTIONS: PPOOption[] = [
  { id: PPO.ALL, label: 'All' },
  { id: PPO.ATA, label: 'ATA' },
  { id: PPO.AZA, label: 'AZA', hasLicense: true },
  { id: PPO.BEA, label: 'BEA' },
  { id: PPO.BGA, label: 'BGA', hasLicense: true },
  { id: PPO.BRA, label: 'BRA', hasLicense: true },
  { id: PPO.CAA, label: 'CAA', hasLicense: true },
  { id: PPO.CFA, label: 'CFA' },
  { id: PPO.CHA, label: 'CHA' },
  { id: PPO.CUA, label: 'CUA', hasLicense: true },
  { id: PPO.CYA, label: 'CYA', hasLicense: true },
  { id: PPO.CZA, label: 'CZA' },
  { id: PPO.DEA, label: 'DEA' },
  { id: PPO.DKA, label: 'DKA' },
  { id: PPO.DZA, label: 'DZA', hasLicense: true },
  { id: PPO.EEA, label: 'EEA' },
  { id: PPO.EGA, label: 'EGA', hasLicense: true },
  { id: PPO.ESA, label: 'ESA' },
  { id: PPO.FIA, label: 'FIA' },
  { id: PPO.FRA, label: 'FRA' },
  { id: PPO.GBA, label: 'GBA' },
  { id: PPO.GHA, label: 'GHA', hasLicense: true },
  { id: PPO.GRA, label: 'GRA' },
  { id: PPO.HKA, label: 'HKA' },
  { id: PPO.HRA, label: 'HRA' },
  { id: PPO.HUA, label: 'HUA' },
  { id: PPO.IEA, label: 'IEA' },
  { id: PPO.IPC, label: 'IPC' },
  { id: PPO.ISA, label: 'ISA' },
  { id: PPO.ITA, label: 'ITA' },
  { id: PPO.JEA, label: 'JEA', hasLicense: true },
  { id: PPO.LTA, label: 'LTA' },
  { id: PPO.LUA, label: 'LUA' },
  { id: PPO.LVA, label: 'LVA' },
  { id: PPO.MTA, label: 'MTA', hasLicense: true },
  { id: PPO.NLA, label: 'NLA' },
  { id: PPO.NOA, label: 'NOA' },
  { id: PPO.PLA, label: 'PLA' },
  { id: PPO.PLG, label: 'PLG' },
  { id: PPO.PTA, label: 'PTA' },
  { id: PPO.PYA, label: 'PYA', hasLicense: true },
  { id: PPO.ROA, label: 'ROA' },
  { id: PPO.RUA, label: 'RUA' },
  { id: PPO.SEA, label: 'SEA' },
  { id: PPO.SGA, label: 'SGA', hasLicense: true },
  { id: PPO.SIA, label: 'SIA' },
  { id: PPO.SKA, label: 'SKA' },
  { id: PPO.SNA, label: 'SNA', hasLicense: true },
  { id: PPO.THA, label: 'THA', hasLicense: true },
  { id: PPO.TRA, label: 'TRA', hasLicense: true },
  { id: PPO.TWA, label: 'TWA', hasLicense: true },
  { id: PPO.USA, label: 'USA' },
  { id: PPO.UYA, label: 'UYA', hasLicense: true }
] as const;

// Playground PPO — special hardcoded option not provided by the API
export const PLAYGROUND_PPO: PPOOption = { id: PPO.PLG, label: 'PLG' };

// Default exports
export const PPOConstants = {
  PPO,
  PPO_OPTIONS
};

export default PPOConstants; 